module.exports = __webpack_public_path__ + "static/media/reencoding_shutterstock_videos_x2.181a5687.mp4";